import { ComponentProps } from '../TagBarTypes'

import { TagBarDefault } from './TagBarDefault'
import { TagBarPlain } from './TagBarPlain'

export const TagBar = (props: ComponentProps) => {
  if (props.variant === 'plainText') return <TagBarPlain {...props} />
  else return <TagBarDefault {...props} />
}
